var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTunisia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.873C24.8366 32.873 32 25.7096 32 16.873C32 8.03649 24.8366 0.873047 16 0.873047C7.16344 0.873047 0 8.03649 0 16.873C0 25.7096 7.16344 32.873 16 32.873Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 24.5248C20.2258 24.5248 23.6518 21.0988 23.6518 16.8726C23.6518 12.6465 20.2258 9.22046 15.9996 9.22046C11.7734 9.22046 8.34741 12.6465 8.34741 16.8726C8.34741 21.0988 11.7734 24.5248 15.9996 24.5248Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9427 13.9467L18.2554 15.7557L20.3815 15.0664L19.0667 16.8739L20.3793 18.6829L18.2539 17.9909L16.9391 19.7984L16.9405 17.5633L14.8152 16.8713L16.9413 16.1819L16.9427 13.9467Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7391 21.3947C15.2419 21.3947 13.2174 19.3702 13.2174 16.873C13.2174 14.3757 15.2419 12.3512 17.7391 12.3512C18.5178 12.3512 19.2504 12.5481 19.8901 12.8947C18.8866 11.9134 17.5144 11.3077 16 11.3077C12.9265 11.3077 10.4348 13.7994 10.4348 16.8729C10.4348 19.9465 12.9265 22.4381 16 22.4381C17.5144 22.4381 18.8867 21.8324 19.8901 20.8511C19.2504 21.1979 18.5178 21.3947 17.7391 21.3947Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.873047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunisia);
export default __webpack_public_path__ + "static/media/tunisia.02b83d24.svg";
export { ForwardRef as ReactComponent };